<template>
  <v-card>
    <v-card-title class="headline py-2">
      Импорт данных
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <input type="file" id="file" ref="file" @change="handleFileUpload" style="display: none;"/>
      <v-btn small @click="selectUpload"><v-icon>mdi-paperclip</v-icon> Загрузить файл</v-btn>
      <span v-if="file">{{file.name}}</span>
      <v-radio-group v-model="orientation" row>
        <v-radio label="Вертикальная ориентация" value="vertical"></v-radio>
        <v-radio label="Горизонтальная ориентация" value="horizontal"></v-radio>
      </v-radio-group>
  
      <v-data-table :headers="headers" :items="objects" hide-actions no-data-text="Объекты отсутствуют">
        <template slot="items" slot-scope="props">
          <td>{{props.item.number}}</td>
          <td>{{props.item.name}}</td>
          <td class="text-xs-center">
            <v-btn slot="activator" icon small flat @click="deleteRow(props.index)" color="error"><v-icon>mdi-delete</v-icon></v-btn>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-right my-2">
        <span class="dashed pointer my-2" @click="showPanel=!showPanel">{{showPanel?'Свернуть панель':'Добавить привязку'}}</span>
      </div>
      
      <v-layout row wrap v-show="showPanel" class="grey lighten-3 px-2 pb-2">
        <v-flex xs12 v-if="index_num==='1'">
          <p class="mb-0 mt-1 pa-0"><v-icon color="red" size="16">mdi-information-outline</v-icon> Номер колонки/ряда не может быть равен 1, т.к. там должна быть дата</p>
        </v-flex>
        <v-flex xs12 md3 class="pr-3">
          <v-text-field label="Номер колонки/ряда в файле" v-model="index_num" hide-details type="number" min="2"></v-text-field>
        </v-flex>
        <v-flex xs12 md7>
          <v-select :items="tableObjects" label="Признаки" hide-details item-text="name" return-object v-model="line"></v-select>
        </v-flex>
        <v-flex xs12 md2 class="text-xs-right">
          <v-btn class="mt-3" color="primary" small @click="addLink" :disabled="line==null || index_num==null || index_num==='1'">Добавить</v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Загрузить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name : "ImportForm",
    
    props : {
      id: {
        type: Number,
        required: true,
      },
      lines : {
        type : Array,
        required : false,
        default: () => []
      },
    },
    
    created(){
      this.tableObjects = this.lines.map( item => {
        let t = 0
        item.id = item.value.join(',')
        item.name = item.text.replace(/\n/g, match => {
          t++;
          return (t === 1) ? "" : "->"
        })
        return item
      })
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        tableObjects: [],
        orientation : 'vertical',
        showPanel: false,
        headers: [
          { text: 'Номер колонки/ряда в файле', align: 'left', sortable: false, width: 90 },
          { text: 'Объект в системе', align: 'left', sortable: false },
          { text: 'Действия', align: 'center', sortable: false, width: 40 },
        ],
        objects: [],
        index_num: null,
        line: null,
        file: null
      }
    },
    
    methods : {
      addLink(){
        if(this.line!=null && this.index_num!=null){
          this.objects.push({
            number: this.index_num,
            properties_ids: this.line.value,
            name: this.line.name
          })
        }
        this.line = null
        this.index_num = null
      },
  
      deleteRow(index){
        this.objects.splice(index, 1)
      },
      
      handleFileUpload(){
        this.file = this.$refs.file.files[0]
      },
      
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
  
        let timezone = this.$store.getters['app/account/accountTimeZone'] || null
        
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('objects', JSON.stringify(this.objects))
        formData.append('orientation', this.orientation)
        formData.append('setting_id', this.id)
        formData.append('timezone', timezone)
        
        this.$store.dispatch('analytics/statistics/importStatistic', formData ).then( response => {
          this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
          this.$emit('save', {type: 'import'} )
        }).catch( error => {
          this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
        })
      },
      
      selectUpload(){
        this.$refs.file.click()
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Forms/ImportForm.vue